import { createRoutes } from "@routes";

export const routes = createRoutes("website");
